export default __webpack_public_path__ + "static/media/addIcon.242fea1c.svg";